const guiManager = {
  init(config) {
    this.gui = document.querySelector('#gui');
    this.playBtn = document.querySelector('#gui-play');
    this.stopBtn = document.querySelector('#gui-stop');
    this.doubleBtn = document.querySelector('#gui-double');
    this.betBtn = document.querySelector('#gui-toggle-bet');
    this.rulesBtn = document.querySelector('#gui-rules');

    this.gui.hidden = false;
    this.autoGame = false;
    this.setState('disabled');
    this.setDouble(false);

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.playBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('play'));
    this.doubleBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('play-double'));
    this.stopBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent(this.autoGame ? 'toggle-auto-game' : 'close-double'));
    this.betBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-bet'));
    this.rulesBtn.addEventListener('click', () => this.eventDispatcher.dispatchEvent('toggle-rules'));

    this.enableAutoGame();

    window.addEventListener('keydown', e => (e.keyCode === 32) &&
      (this.double ? this.stopBtn.click() : this.playBtn.click()));
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  setDouble(double) {
    this.double = double;
    this.playBtn.hidden = double;
    this.doubleBtn.hidden = !double;
    this.stopBtn.hidden = !double;

    if (double) {
      // сразу с изменением дисплея анимации не работают
      setTimeout(() => {
        this.doubleBtn.classList.add('gui__play-btn--first');
        this.stopBtn.classList.add('gui__play-btn--second');
      }, 0);
    }
  },

  setAutoGame(auto) {
    this.autoGame = auto;
    this.stopBtn.disabled = !auto;
    this.stopBtn.classList.toggle('btn-round--fill');
  },

  setDoubleStep() {},

  setState(state) {
    this.state = state;

    const btns = [
      this.rulesBtn,
      this.doubleBtn,
      this.playBtn,
      this.stopBtn,
      this.betBtn,
    ];

    btns.forEach((btn) => {
      btn.classList.remove('btn--active');
      btn.disabled = false; // eslint-disable-line no-param-reassign
    });

    this.playBtn.hidden = this.double;
    this.stopBtn.hidden = !this.double;
    this.doubleBtn.hidden = !this.double;
    if (!this.double) {
      this.doubleBtn.classList.remove('gui__play-btn--first');
      this.stopBtn.classList.remove('gui__play-btn--second');
    }

    if (this.autoGame) {
      this.rulesBtn.disabled = true;
      this.playBtn.disabled = true;
      this.betBtn.disabled = true;

      this.playBtn.hidden = true;
      this.stopBtn.hidden = false;
      return;
    }

    switch (state) {
      case 'disabled':
        btns.forEach((btn) => {
          btn.disabled = true; // eslint-disable-line no-param-reassign
        });
        break;

      case 'ready':
        break;

      case 'bet':
        this.betBtn.classList.add('btn--active');
        this.playBtn.disabled = true;
        this.stopBtn.disabled = true;
        break;

      case 'rules':
        this.rulesBtn.classList.add('btn--active');
        this.playBtn.disabled = true;
        this.stopBtn.disabled = true;
        break;

      case 'not-ready':
        this.playBtn.disabled = true;
        this.stopBtn.disabled = true;
        break;

      default:
        throw new Error('invalid state');
    }
  },

  enableAutoGame() {
    const activationDelay = 1000;
    let timeoutID = null;

    const cancelTimeout = () => {
      clearTimeout(timeoutID);
      timeoutID = null;
      this.playBtn.classList.remove('btn-round--fill');
    };

    const onTimeout = () => {
      this.eventDispatcher.dispatchEvent('toggle-auto-game');
      cancelTimeout();
    };

    const startTimeout = () => {
      if (this.playBtn.disabled || timeoutID) {
        return;
      }

      this.playBtn.classList.add('btn-round--fill');
      timeoutID = setTimeout(onTimeout, activationDelay);
    };

    this.playBtn.addEventListener('pointerdown', startTimeout);
    this.playBtn.addEventListener('pointerup', cancelTimeout);
    this.playBtn.addEventListener('pointerleave', cancelTimeout);
    this.playBtn.addEventListener('pointercancel', cancelTimeout);
  },
};

export default guiManager;



// WEBPACK FOOTER //
// ../base/js/managers/gui.js